module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/2_e19e61d04c6ff88eabc2dfd0833f8cb9.png";